import Dexie, { Table } from "dexie";
import { DEFAULT_NETWORK } from "src/constants/config";
import { WPPost, WPPostComment, WPCategory } from "src/types/wp";

class EcosystemDB extends Dexie {
  posts!: Table<WPPost, number>;
  postComments!: Table<WPPostComment, number>;
  categories!: Table<WPCategory, number>;
  configs!: Table;
  constructor() {
    super(`WPressPostsDB-${DEFAULT_NETWORK}-stratos`);
    this.init();
  }

  async init() {
    this.version(3).stores({
      posts: "++id",
      postComments: "++id, post",
      categories: "++id",
      configs: "key",
    });
    await this.openDB();
  }

  async openDB() {
    await this.open().catch(function (e) {
      console.error("Database open failed: " + e);
    });
  }

  async closeDB() {
    this.close();
  }

  async getConfigValues(key: string) {
    try {
      const result = await this.table("configs")
        .where("key")
        .equals(key)
        .toArray();
      return result[0].value;
    } catch (_) {
      return undefined;
    }
  }

  async setConfigValues(key: string, value: any) {
    try {
      await this.transaction("rw", [this.table("configs")], async () => {
        await this.table("configs").put({ key, value });
      });
    } catch (e) {
      console.log(
        "Failed to store application configuration information in database",
        e,
      );
    }
  }

  async getCategories(): Promise<WPCategory[]> {
    try {
      const result = await this.table("categories").toArray();
      return result;
    } catch (_) {
      return [];
    }
  }

  async getPosts(): Promise<WPPost[]> {
    try {
      const result = await this.table("posts").toArray();
      return result;
    } catch (_) {
      return [];
    }
  }

  async getPostComments(): Promise<WPPostComment[]> {
    try {
      const result = await this.table("postComments").toArray();
      return result;
    } catch (_) {
      return [];
    }
  }

  async setCategories(categories: WPCategory[]) {
    try {
      await this.transaction("rw", [this.table("categories")], async () => {
        await this.table("categories").toCollection().delete();
        for (let i = 0; i < categories.length; i++) {
          await this.table("categories").put(categories[i]);
        }
      });
    } catch (e) {
      console.log("Database storage categories failed", e);
    }
  }

  async setPosts(posts: WPPost[]) {
    try {
      await this.transaction("rw", [this.table("posts")], async () => {
        await this.table("posts").toCollection().delete();
        for (let i = 0; i < posts.length; i++) {
          await this.table("posts").put(posts[i]);
        }
      });
    } catch (e) {
      console.log("Database storage posts failed", e);
    }
  }

  async setPostComments(postComments: WPPostComment[]) {
    console.log("aa saving postComments", postComments);
    try {
      await this.transaction("rw", [this.table("postComments")], async () => {
        await this.table("postComments").toCollection().delete();
        for (let i = 0; i < postComments.length; i++) {
          await this.table("postComments").put(postComments[i]);
        }
      });
    } catch (e) {
      console.log("Database storage postComments failed", e);
    }
  }
}

export const db = new EcosystemDB();

export function resetDatabase() {
  return db.transaction(
    "rw",
    db.posts,
    db.postComments,
    db.categories,
    async () => {
      await Promise.all(db.tables.map((table) => table.clear()));
    },
  );
}
